var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4227",
    "data-name": "Rectangle 4227",
    width: 26,
    height: 26,
    transform: "translate(660 309)",
    fill: "#f28e39"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(-660 -309)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-question-01",
    transform: "translate(659.833 309.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9927",
    "data-name": "Path 9927",
    d: "M18.417,19.966H14.083L9.263,23.173a1.08,1.08,0,0,1-1.679-.9V19.966a5.118,5.118,0,0,1-5.417-5.417v-6.5A5.118,5.118,0,0,1,7.583,2.633H18.417a5.118,5.118,0,0,1,5.417,5.417v6.5A5.118,5.118,0,0,1,18.417,19.966Z",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9928",
    "data-name": "Path 9928",
    d: "M13,12.307v-.227a1.7,1.7,0,0,1,.91-1.441A1.66,1.66,0,0,0,14.8,9.23a1.8,1.8,0,1,0-3.6,0",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9929",
    "data-name": "Path 9929",
    d: "M12.995,14.9H13",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpInactive);
export default __webpack_public_path__ + "static/media/help_inactive.66c027c111d17704683e8cd74355edab.svg";
export { ForwardRef as ReactComponent };